import { render, staticRenderFns } from "./InputSuratBpkb.vue?vue&type=template&id=61a0650a&"
import script from "./InputSuratBpkb.vue?vue&type=script&lang=js&"
export * from "./InputSuratBpkb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports